import { render, staticRenderFns } from "./yqg-icon-nav.vue?vue&type=template&id=ca63e5c4&scoped=true&"
import script from "./yqg-icon-nav.vue?vue&type=script&lang=js&"
export * from "./yqg-icon-nav.vue?vue&type=script&lang=js&"
import style0 from "./yqg-icon-nav.vue?vue&type=style&index=0&id=ca63e5c4&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca63e5c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/fintopia-web7chz7/fintopia-web-ci/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca63e5c4')) {
      api.createRecord('ca63e5c4', component.options)
    } else {
      api.reload('ca63e5c4', component.options)
    }
    module.hot.accept("./yqg-icon-nav.vue?vue&type=template&id=ca63e5c4&scoped=true&", function () {
      api.rerender('ca63e5c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/vue/component/yqg-icon-nav/yqg-icon-nav.vue"
export default component.exports